import { render } from "./SunsureOverview.vue?vue&type=template&id=d728d5fa&scoped=true"
import script from "./SunsureOverview.vue?vue&type=script&lang=js"
export * from "./SunsureOverview.vue?vue&type=script&lang=js"

import "./SunsureOverview.vue?vue&type=style&index=0&id=d728d5fa&scoped=true&lang=postcss"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d728d5fa"]])

export default __exports__